export class DataProcess {
    Usuario: any;
}